const OurLocation = ({ settings }) => {
  return (
    <>
      {settings && (
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-md-3 mb-3">
          <div className="phone-number" id="miami-location-scroll">
            <h2 className="big-heading text-capitalize mb-2 mb-md-2">
              Our Locations
            </h2>
            <a href="tel:(305) 513-0063">{settings.site_phone}</a>
            <a href="tel:1-888-41-METRO" className="mx-2">
              <strong>{settings.site_phone_2}</strong>
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default OurLocation;
